import { Component } from '@angular/core';

@Component({
    selector: 'coupon',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class CouponsComponent {}
